import DOMPurify from 'dompurify';

interface SanitizeHtmlProps {
  html?: string;
}

const SanitizeHtml = ({ html = '' }: SanitizeHtmlProps) => {
  const sanitizedData = () => ({
    __html: DOMPurify.sanitize(html),
  });

  return <div dangerouslySetInnerHTML={sanitizedData()}></div>;
};

export default SanitizeHtml;
